import React from "react";
import { useHistory, useParams, useLocation } from "react-router-dom";

import Button from "@/components/atoms/Buttons/Button";
import Footer from "@/components/molecules/Footer";
import Header from "@/components/molecules/Header";
import i18n from "@/translate/i18n";

import { Title } from "@/components/atoms/Typography/styles";
import { ReactComponent as SofIcon } from "@/assets/images/sof.svg";

import { LayoutWrapper } from "@/components/molecules/Wrappers/LayoutWrapper";

function SOFValidation() {
  const history = useHistory();
  const location = useLocation();
  const { customerId, token } = useParams();

  const transactionState = location.state;

  return (
    <div className="flex justify-center items-center bg-white sm:bg-gray-900 font-arboria-book min-h-screen overflow-x-hidden">
      <div className="flex flex-col justify-between items-center w-[500px] rounded-[20px] overflow-hidden text-center">
        <Header title={i18n.t("header.return")} />
        <LayoutWrapper>
          <SofIcon className="w-14 mt-8" />
          <div className="mt-8">
            <Title widthFull>{i18n.t("sofValidation.title")}</Title>
          </div>
          <h3 className="mt-5 font-medium text-md text-black max-w-[80%]">
            {i18n.t("sofValidation.description")}
          </h3>
          <h3 className="font-medium text-md text-black max-w-[80%]">
            {i18n.t("sofValidation.description2")}
          </h3>
          <Button
            type="button"
            handleClick={() =>
              history.push(
                `/kyc/3/customer/${customerId}/${token}/sof${history.location.search}`,
                transactionState,
              )
            }
          >
            {i18n.t("sofValidation.buttonLabel")}
          </Button>
        </LayoutWrapper>
        <Footer />
      </div>
    </div>
  );
}

export default SOFValidation;
